import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RedeemRequest } from "src/interfaces/RedeemRequest";

interface RedeemRequestsState {
  redeemRequests: RedeemRequest[];
  isSubscribed: boolean;
}

const initialState: RedeemRequestsState = {
  redeemRequests: [],
  isSubscribed: false,
};

export const redeemRequestsSlice = createSlice({
  name: "redeem-requests",
  initialState,
  reducers: {
    setRedeemRequests: (state, action: PayloadAction<RedeemRequest[]>) => {
      state.redeemRequests = action.payload;
      state.isSubscribed = true;
    },
  },
});

export const { setRedeemRequests } = redeemRequestsSlice.actions;

export default redeemRequestsSlice.reducer;
